import React, { useEffect, useState } from 'react';

interface DataEstatitica {
    dadosciclo: any;
}

const Estatistica: React.FC<DataEstatitica> = ({dadosciclo}) => {

    const [estats, setEstats] = useState<any>({})

    useEffect(() => {
        /*setTotalDias(dadosciclo.length);
        setSangramento(dadosciclo.filter((e: any) => parseFloat(e.sensacao) === 1).length);
        setFertil(dadosciclo.filter((e: any) => parseFloat(e.sensacao) === 2 || parseFloat(e.sensacao) === 6 || parseFloat(e.sensacao) === 7 ).length);
        setInfertil(dadosciclo.filter((e: any) => parseFloat(e.sensacao) === 3 || parseFloat(e.sensacao) === 4 || parseFloat(e.sensacao) === 5 ).length);
        setRelacoes(dadosciclo.filter((e: any) => parseFloat(e.relacao) === 1).length);
        */
        const total = dadosciclo.length;
        const sangr = dadosciclo.filter((e: any) => parseFloat(e.selo) === 1).length;
        const ferti = dadosciclo.filter((e: any) => parseFloat(e.selo) === 4).length;
        const infer = dadosciclo.filter((e: any) => parseFloat(e.selo) === 2 || parseFloat(e.selo) === 3 ).length;
        const relac = dadosciclo.filter((e: any) => parseFloat(e.relacao) === 1).length;

        const res = {
            total,
            sangr,
            ferti,
            infer,
            relac,
          };
        setEstats(res);

    },  [dadosciclo]);

    return (
        <div className="padpadrao estatistica">
           
          <div><strong>CICLO COM:</strong></div>
          <div style={{textAlign: 'right'}}>{estats.total} DIAS</div>
      
          <div><strong>FLUXO (SANGUE):</strong></div>
          <div style={{textAlign: 'right'}}>{estats.sangr} DIAS</div>
      
          <div><strong>DIAS DE FERTILIDADE:</strong></div>
          <div style={{textAlign: 'right'}}>{estats.ferti} DIAS</div>
      
          <div><strong>INFERTIL (SECA/ÚMIDA):</strong></div>
          <div style={{textAlign: 'right'}}>{estats.infer} DIAS</div>
      
          <div><strong>RELAÇÕES:</strong></div>
          <div style={{textAlign: 'right'}}>{estats.relac} DIAS</div>
              
        </div>
    );
}

export default Estatistica;
